import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Work from "@/components/site/Work";
import Packages from "@/components/site/Packages";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import useReveal from "@/lib/useReveal";
import AdminPage from "@/pages/AdminPage";

function Landing() {
  useReveal();

  useEffect(() => {
    document.title = "Maison Locale — Luxury Airbnb Branding Studio";
  }, []);

  return (
    <div className="App" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Stats />
        <Work />
        <Packages />
        <Process />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FAF9F6",
            border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: "2px",
            fontFamily: "'Outfit', sans-serif",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/studio" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
